export default __webpack_public_path__ + "static/media/htmlC.1ea9f714.webp";